<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Workspace Config</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <input #file type="file" multiple (change)="onFilesAdded()" />
        @if (siteConfig$ | async) {
            <form [formGroup]="form" class="flex column">
                <div class="flex row item">
                    <div class="flex-60">
                        <h3>Name of the Workspace</h3>
                        <p>This will show up in the page title and in emails and notifications</p>
                    </div>
                    <div class="flex-35">
                        <mat-form-field appearance="fill">
                            <mat-label>Name</mat-label>
                            <input matInput formControlName="name" />
                        </mat-form-field>
                    </div>
                    @if (propertyRequest.property === "name") {
                        <div class="flex-5">
                            @if (propertyRequest.state === 1) {
                                <mat-progress-spinner
                                    mode="indeterminate"
                                    diameter="24"
                                ></mat-progress-spinner>
                            }
                            @if (propertyRequest.state === 2) {
                                <mat-icon>done</mat-icon>
                            }
                            @if (propertyRequest.state === 3) {
                                <mat-icon [matTooltip]="propertyRequest.message" color="warn"
                                    >error</mat-icon
                                >
                            }
                        </div>
                    }
                </div>
                <div class="flex row item">
                    <div class="flex-60">
                        <h3>Workspace Image</h3>
                        <p>This will show up in the page title and in emails and notifications</p>
                    </div>
                    <div class="flex-35">
                        <frog-workspace-button [siteConfig]="siteConfig"></frog-workspace-button>
                        <button mat-button (click)="addFiles()" matTooltip="Upload">
                            <mat-icon>file_upload</mat-icon>
                            <span> Browse</span>
                        </button>
                    </div>
                    @if (propertyRequest.property === "thumbnail") {
                        <div class="flex-5">
                            @if (propertyRequest.state === 1) {
                                <mat-progress-spinner
                                    mode="indeterminate"
                                    diameter="24"
                                ></mat-progress-spinner>
                            }
                            @if (propertyRequest.state === 2) {
                                <mat-icon>done</mat-icon>
                            }
                            @if (propertyRequest.state === 3) {
                                <mat-icon [matTooltip]="propertyRequest.message" color="warn"
                                    >error</mat-icon
                                >
                            }
                        </div>
                    }
                </div>
                <div class="flex row item">
                    <div class="flex-60">
                        <h3>Default Stream</h3>
                        <p>This will be the Stream that users will be directed to by default</p>
                    </div>
                    <div class="flex-35">
                        <mat-form-field appearance="fill">
                            <mat-label>Default Stream</mat-label>
                            <mat-select required formControlName="primary_stream">
                                @for (stream of streams$ | async; track stream) {
                                    <mat-option [value]="stream.id">{{ stream.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    @if (propertyRequest.property === "primary_stream") {
                        <div class="flex-5">
                            @if (propertyRequest.state === 1) {
                                <mat-progress-spinner
                                    mode="indeterminate"
                                    diameter="24"
                                ></mat-progress-spinner>
                            }
                            @if (propertyRequest.state === 2) {
                                <mat-icon>done</mat-icon>
                            }
                            @if (propertyRequest.state === 3) {
                                <mat-icon [matTooltip]="propertyRequest.message" color="warn"
                                    >error</mat-icon
                                >
                            }
                        </div>
                    }
                </div>
                <div class="flex row item">
                    <div class="flex-60">
                        <h3>Enable Likes</h3>
                        <p>Allow users to "Like" assets</p>
                    </div>
                    <div class="flex-35">
                        <mat-slide-toggle
                            formControlName="enable_likes"
                            color="primary"
                        ></mat-slide-toggle>
                    </div>
                    @if (propertyRequest.property === "enable_likes") {
                        <div class="flex-5">
                            @if (propertyRequest.state === 1) {
                                <mat-progress-spinner
                                    mode="indeterminate"
                                    diameter="24"
                                ></mat-progress-spinner>
                            }
                            @if (propertyRequest.state === 2) {
                                <mat-icon color="primary">done</mat-icon>
                            }
                            @if (propertyRequest.state === 3) {
                                <mat-icon [matTooltip]="propertyRequest.message" color="warn"
                                    >error</mat-icon
                                >
                            }
                        </div>
                    }
                </div>
                <div class="flex row item">
                    <div class="flex-60">
                        <h3>Display Likes</h3>
                        <p>Show the "Likes" count on assets</p>
                    </div>
                    <div class="flex-35">
                        <mat-slide-toggle
                            formControlName="display_likes"
                            [disabled]="!form.value.enable_likes"
                            color="primary"
                        ></mat-slide-toggle>
                    </div>
                    @if (propertyRequest.property === "display_likes") {
                        <div class="flex-5">
                            @if (propertyRequest.state === 1) {
                                <mat-progress-spinner
                                    mode="indeterminate"
                                    diameter="24"
                                ></mat-progress-spinner>
                            }
                            @if (propertyRequest.state === 2) {
                                <mat-icon color="primary">done</mat-icon>
                            }
                            @if (propertyRequest.state === 3) {
                                <mat-icon [matTooltip]="propertyRequest.message" color="warn"
                                    >error</mat-icon
                                >
                            }
                        </div>
                    }
                </div>
            </form>
        }
    </mat-card-content>
</mat-card>
